<div class="otp-page fade-in">
    <div class="otp-panel view-container">
        <header class="otp-header">
            <img src="assets/logo_corecredit_2.png" alt="Corecredit" class="otp-logo" width="160" height="40"
                loading="eager" />
            <h1 id="otp-title" class="view-title">Verificación segura</h1>
            <p class="view-subtitle otp-lead">
                Ingresa el código de 6 dígitos que enviamos a tu celular
                <strong class="otp-mask">{{ (currentUser$ | async)?.maskedPhone || '••••••' }}</strong>
                y a tu correo
                <strong class="otp-mask">{{ (currentUser$ | async)?.maskedEmail || '••••••' }}</strong>.
            </p>
        </header>

        <form class="otp-form" (ngSubmit)="onSubmit($event)" novalidate>
            <div class="otp-verification">
                <app-core-otp [length]="6" (otpChange)="onOtpChange($event)" (otpComplete)="onOtpComplete($event)">
                </app-core-otp>

                <div class="otp-resend">
                    @if (timeLeft > 0) {
                        <span class="otp-resend-text">
                            Podrás solicitar un nuevo código en
                            <span class="otp-timer">{{ formattedTime }}</span>
                        </span>
                    } @else {
                        <span class="otp-resend-text">¿No recibiste el código?</span>
                        <button type="button" class="otp-resend-button" (click)="onResendCode()" [disabled]="isLoading">
                            <fa-icon [icon]="icons.falArrowsRotate" aria-hidden="true"></fa-icon>
                            Reenviar código
                        </button>
                    }
                </div>
            </div>

            <div class="actions-group text-right">
                <app-core-button label="Verificar acceso" type="submit"
                    [disabled]="!isOtpComplete || isLoading" [isLoading]="isLoading">
                </app-core-button>
            </div>

            <div class="otp-footer">
                <a routerLink="/personas/ingreso" class="otp-link-back">
                    <fa-icon [icon]="icons.falArrowLeft" class="otp-link-back-icon" aria-hidden="true"></fa-icon>
                    Cambiar documento
                </a>
            </div>
        </form>
    </div>
</div>
